import { createStore } from 'vuex';
import dispatchActionForAllModules from '@/common/dispatch-action-for-all-modules';
import modules from '@/store/modules';

export default createStore({
	modules,
	strict: process.env.NODE_ENV !== 'production',
});
dispatchActionForAllModules('init');
